<script>
import moment from 'moment';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import api from '@/modules/costable/_api';

export default {
    name: 'DateRangeInput',
    components: {
        DateRangePicker,
    },
    props: {
        initialValue: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            locale: {
                format: 'yyyy-mm-dd',
                firstDay: 1,
                separator: ' - ',
            },
            value: '',
            type: 'fixed',
            weekStart: null,
        };
    },
    computed: {
        dateRange: {
            get() {
                if (!this.valueIsFixedRange) {
                    return {
                        startDate: '',
                        endDate: '',
                    };
                }

                return {
                    startDate: this.value ? this.value.split(' - ')[0] : '',
                    endDate: this.value ? this.value.split(' - ')[1] : '',
                };
            },
            set(value) {
                this.value = `${moment(value.startDate).format('YYYY-MM-DD')} - ${moment(value.endDate).format('YYYY-MM-DD')}`;
            },
        },
        valueIsFixedRange() {
            return this.value.includes(' - ');
        },
        ranges() {
            const weekStart = this.weekStart ?? 0; // Default to Sunday if not set
            return {
                Today: this.formatPresetRange(moment(), moment()),
                Yesterday: this.formatPresetRange(moment().subtract(1, 'days'), moment().subtract(1, 'days')),
                'This week': this.formatPresetRange(moment().day(weekStart), moment().day(weekStart).add(6, 'days')),
                'Next week': this.formatPresetRange(moment().add(1, 'week').day(weekStart), moment().add(1, 'week').day(weekStart).add(6, 'days')),
                'Last week': this.formatPresetRange(moment().subtract(1, 'week').day(weekStart), moment().subtract(1, 'week').day(weekStart).add(6, 'days')),
                'Next 7 Days': this.formatPresetRange(moment(), moment().add(7, 'days')),
                'Last 7 Days': this.formatPresetRange(moment().subtract(7, 'days'), moment()),
                'Next 30 Days': this.formatPresetRange(moment(), moment().add(30, 'days')),
                'Last 30 Days': this.formatPresetRange(moment().subtract(30, 'days'), moment()),
                'This Month': this.formatPresetRange(moment().startOf('month'), moment().endOf('month')),
                'Next Month': this.formatPresetRange(moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')),
                'Last Month': this.formatPresetRange(moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')),
                'This Year': this.formatPresetRange(moment().startOf('year'), moment().endOf('year')),
                'Next Year': this.formatPresetRange(moment().add(1, 'year').startOf('year'), moment().add(1, 'year').endOf('year')),
                'Last Year': this.formatPresetRange(moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')),
            };
        },
    },
    mounted() {
        this.value = this.initialValue;

        this.type = this.value.includes(' - ') || this.value === ''
            ? 'fixed'
            : 'relative';

        api.getSettings()
            .then((response) => {
                this.weekStart = response.week_start;
            });
    },
    methods: {
        toggleType() {
            this.type = this.type === 'fixed'
                ? 'relative'
                : 'fixed';
        },
        capitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        formatPresetRange(start, end) {
            return [
                start.toDate(),
                end.toDate(),
            ];
        },
    },
};
</script>

<template>
    <div class="d-flex justify-content-center align-items-center">
        <input
            v-if="type === 'relative'"
            type="text"
            class="form-control"
            :name="name"
            :value="value"
            placeholder="e.g. last 7 days"
        >
        <template v-else>
            <date-range-picker
                v-model="dateRange"
                :locale-data="locale"
                :ranges="ranges"
            >
                <template #input="picker">
                    <div class="d-flex align-items-center">
                        <i class="fa fa-calendar fa-fw mr-2 text-muted" />
                        <span>{{ picker.rangeText }}</span>
                        <i class="fa fa-caret-down fa-fw ml-auto" />
                    </div>
                </template>
            </date-range-picker>
            <input
                type="hidden"
                class="form-control"
                :name="name"
                :value="value"
            >
        </template>
        <button
            type="button"
            class="btn btn-outline-secondary ml-3"
            @click="toggleType"
        >
            {{ capitalize(type) }}&nbsp;range
        </button>
    </div>
</template>

<style
    scoped
    lang="scss"
>
.vue-daterange-picker {
    width: 100%;
    display: block;
}

.reportrange-text {
    @apply d-flex align-content-center;
}
</style>
